import { render, staticRenderFns } from "./BracketDiagram.vue?vue&type=template&id=18a02d6d&scoped=true"
import script from "./BracketDiagram.vue?vue&type=script&lang=js"
export * from "./BracketDiagram.vue?vue&type=script&lang=js"
import style0 from "./BracketDiagram.vue?vue&type=style&index=0&id=18a02d6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a02d6d",
  null
  
)

export default component.exports